export const EMAIL_PATTERN = /^(([^<>!#$%&\^\*()\[\]\\.,;:\s@'"?`~]+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ONLY_CHAR = "^[a-zA-Z ]+$";
export const CHAR_WITH_NUMBER = "^[a-zA-Z0-9_ ]*$";
export const COUNTER = 2;
export const SECONDS = 59;
export const COUNTRY_CODE = '+91';
export const RAZOR_PAY_URL = 'https://checkout.razorpay.com/v1/checkout.js';
export const TAWK_CHAT_URL = 'https://tawk.to/chat/5ea2daed69e9320caac6ed8b/1fg63kcag';
export const PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.yumzy.orderfood';
export const APPSTORE_URL = 'https://apps.apple.com/in/app/yumzy-food-ordering-delivery/id1476665049';
export const GRATIFICATION_SOUND = 'https://sgp1.digitaloceanspaces.com/listing/yumzy/app/audio/confetti.mp3';

export const ACCOUNT_ITEMS = [
  { name: 'Manage Addresses', icon: 'assets/icon/account/manage-address.svg', type: 'MANAGE_ACCOUNT', url: 'manage-address' },
  // { name: 'Food Preferences', icon: 'assets/icon/account/food-preferences.svg', type: 'FOOD_PREFERENCES', url: 'food-preferences' },
  { name: 'Chacha Coin', icon: 'assets/icon/account/my-wallet.svg', type: 'MY_WALLET', url: 'my-wallet' },
  { name: 'Favourites', icon: 'assets/icon/account/favorite.svg', type: 'FAVORITES', url: 'favorites' },
  { name: 'My Rewards', icon: 'assets/icon/account/my-rewards.svg', type: 'MY_REWARDS', url: 'earned-scratch-cards' },
  { name: 'Order History', icon: 'assets/icon/account/orders-history.svg', type: 'ORDERS_HISTORY', url: 'order-history' },
  { name: 'Refer & Earn ', icon: 'assets/icon/account/orders-history.svg', type: 'REFER_EARN', url: 'refer-earn' },
  { name: 'Help & FAQs', icon: 'assets/icon/account/help-faqs.svg', type: 'HELP_FAQS', url: 'help-faqs' }
]

export const NAV_ITEM = [
  {
    name: 'Home',
    class: 'icon-home',
    url: '/home',
    type: 'HOME',
  },
  // {
  //   name: 'Explore',
  //   class: 'icon-search',
  //   url: '/explore',
  //   type: 'EXPLORE',
  // },
  {
    name: 'Cart',
    class: 'icon-cart',
    url: '/cart',
    type: 'YOUR_PLATE',
  },
  {
    name: 'Profile',
    class: 'icon-profile',
    url: '/account',
    type: 'ACCOUNT',
  },
]
export const OfferColors = [
  {
    backgroundColor: "#F672801A",
    border: "#BC3357"
  },
  {
    backgroundColor: "#9072F61A",
    border: "#4833BC"
  },
  {
    backgroundColor: "#72F6AA1A",
    border: "#43BC33"
  }

]

export const ALLOWED_IMAGE_TYPE = [
  'image/png',
  'image/PNG',
  'image/jpg',
  'image/JPG',
  'image/jpeg',
  'image/JPEG',
];

export const FOOD_PREFERENCES_FILTER_LIST = [
  { name: 'anything', val: 'anything', img: 'assets/icon/account/food-preferences/anything-food.svg' },
  { name: 'vegetarian', val: 'veg', img: 'assets/icon/account/food-preferences/vegetarian-food.svg' },
  { name: 'non vegetarian', val: 'nonveg', img: 'assets/icon/account/food-preferences/non-vegetarian-food.svg' },
]
export const deliveryTypeMessage = [
  // {
  //   name: "Delivery",
  //   text: "Order will be delivered at your selected address.",
  // },
  // {
  //   name: "Self-Pick up",
  //   text: "You have to pick up the order yourself from the restaurant.",
  // },
  {
    name: "delivery",
    text: "Order will be delivered by us.",
  },
  {
    name: "self-pickup",
    text: "Pick-up your order from the restaurant.",
  },
];

export function getOWLCarouselConfig(type) {
  const MESSAGES = {
    COMMON_OPTIONS: {
      autoWidth: true,
      navSpeed: 0,
      center: false,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        400: {
          items: 2,
        },
        740: {
          items: 3,
        },
        940: {
          items: 4,
        }
      },
      nav: false
    }, INFO_BAR_OPTIONS: {
      autoWidth: true,
      navSpeed: 700,
      center: false,
      dots: false,
      loop: true,
      dragging: true,
      autoplay: true,
      responsive: {
        0: {
          items: 1,
        },
        770: {
          items: 2,
        },
        940: {
          items: 2,
        }
      },
      nav: false,
      navText: ['', ''],
    },
    FULL_WDT_BANNER_OPTIONS: {
      navSpeed: 0,
      center: false,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        400: {
          items: 1,
        },
        740: {
          items: 1,
        },
        940: {
          items: 1,
        }
      },
      nav: false
    },
    EXPLORE_BANNER_OPTIONS: {
      autoWidth: true,
      navSpeed: 600,
      center: true,
      dots: true,
      loop: true,
      responsive: {
        0: {
          items: 1,
        },
        400: {
          items: 2,
        },
        740: {
          items: 3,
        },
      },
    },
  };
  return MESSAGES[type];
}

export function ionSlideOpts(type) {
  const MESSAGES = {
    COMMON_OPTIONS: {
      speed: 400
    },
    WINTER_SPL: {
    },
    NEW_LAUNCHED: {
      width: 190
    },
    YUMZY_BEST: {
      width: 270
    },
    POPULAR_CUISINES: {
      width: 115
    },
    TOP_BRANDS: {
      width: 120
    },
    MULTI_ADD: {
      width: 135
    },
    POPULAR_FOOD: {
      width: 270
    },
    BANNERS: {
    },
    INFO_BAR: {
      // autoplay: true
    },
    BEST_SELLER: {
      width: 194
    }
  }

  return MESSAGES[type];
}

export function getLottieConfig(type) {
  const CONFIG = {
    SELECT_LOCATION_LOTTIE_CONFIG: {
      path: 'assets/lotties-files/select-location.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true
    },
    EXPLORE_LOTTIE_CONFIG: {
      path: 'assets/lotties-files/explore-page.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true
    },
    REWARD_ILLUSTRATION_LOTTIE_CONFIG: {
      path: 'assets/lotties-files/rewards-invate.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true
    },
    SKELETON_LOADING_LOTTIE_CONFIG: {
      path: 'assets/lotties-files/hafl-skeleton-loading-card.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true,

    },
    WELCOME_PAGE_LOTTIE_CONFIG: {
      TYPE_1: {
        path: 'assets/lotties-files/welcome_screen_1.json',
        renderer: 'svg',
        autoplay: true,
        loop: false
      },
      TYPE_2: {
        path: 'assets/lotties-files/welcome_screen_2.json',
        renderer: 'svg',
        autoplay: true,
        loop: false
      }
    },
    GIFT_REWARDS_CONFIG: {
      path: 'assets/lotties-files/gift-rewards.json',
      renderer: 'canvas',
      autoplay: true,
      loop: false,
      showConfig: false
    },
    SUCCESS_CONFIG: {
      path: 'assets/lotties-files/success-animation.json',
      renderer: 'canvas',
      autoplay: true,
      loop: false,
      showConfig: false
    },
    OUTLET_UNAVAILABLE_CONFIG: {
      path: 'assets/lotties-files/No-outlet-blinker.json',
      renderer: 'canvas',
      autoplay: true,
      loop: false,
      showConfig: false
    },
    TRACK_ORDER_INFO_BAR_CONFIG: {
      path: 'assets/lotties-files/order-track.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true,
      showConfig: false
    },
    SCRATCH_WON_CONFIG: {
      path: 'assets/lotties-files/confetti-transparent.json',
      renderer: 'svg',
      autoplay: true,
      loop: false,
      showConfig: false
    },
    COUPON_CAN_CONFIG: {
      path: 'assets/lotties-files/confetti-transparent.json',
      renderer: 'svg',
      autoplay: false,
      loop: false,
      showConfig: false
    },
    CONFIRMATION_CHECK: {
      path: 'assets/lotties-files/success.json',
      renderer: 'canvas',
      autoplay: true,
      loop: false,
      showConfig: false
    },
    LOADING_SPINNER: {
      path: 'assets/lotties-files/spinner.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true,
      showConfig: false
    },
    FAILURE_CHECK: {
      path: 'assets/lotties-files/spinner-fail.json',
      renderer: 'canvas',
      autoplay: true,
      loop: false,
      showConfig: false
    },
    CLOUD_INFO_BAR_CONFIG: {
      path: 'assets/lotties-files/Cloud.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true,
      showConfig: false
    },
    STAR_ANIMATION_LOTTIE_CONFIG: {
      path: 'assets/lotties-files/Cloud.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true,
      showConfig: false
    },
    ACCOUNT_DELETE_CONFIG:{
      path: 'assets/lotties-files/account-delete.json',
      renderer: 'canvas',
      autoplay: true,
      loop: false,
      showConfig: false
    }
  };

  return CONFIG[type];
}

export function getConfig(type) {
  const CONFIG = {
    LOCATION_MODAL_CONFIG: {
      windowClass: 'modal fade come-from-modal hide-scroll-view left',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    CONFIRM_MODAL_CONFIG: {
      windowClass: 'confirmation-modal-css',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    RATING_MODAL_CONFIG: {
      windowClass: 'rating-modal-mobile-css',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    ADDON_VARIANT_CONFIG: {
      windowClass: 'addon-variant-modal-css',
      backdrop: true,
      scrollable: true,
      centered: true
    },

    CONFIRM_MODAL_TYPE2_CONFIG: {
      windowClass: 'confirm-modal-type2-css',
      backdrop: true,
      scrollable: true,
      centered: true
    },
    MENU_CATEGORY_CONFIG: {
      windowClass: 'categoryModal',
      backdrop: true,
      scrollable: false,
      centered: true,
    },
    CLEAR_PLATE_CONFIG: {
      windowClass: 'clearPlateModal',
      backdrop: true,
      scrollable: true,
      centered: true,
    },
    ADDON_REPEAT_CONFIG: {
      windowClass: 'modal fade come-from-modal bottom-modal',
      backdrop: true,
      scrollable: true,
      centered: true,
    },
    CHANGE_ADDRESS_CONFIG: {
      windowClass: 'change-address-modal-css',
      backdrop: true,
      scrollable: true,
      centered: true
    },
    FROM_RIGHT_MODAL: {
      windowClass: 'modal fade come-from-modal right',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    FROM_BOTTOM_MODAL: {
      windowClass: 'modal fade come-from-modal bottom-modal',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    ORDER_PLACED_MSG_CONFIG: {
      windowClass: 'order-place-modal',
      backdrop: false,
      scrollable: false,
      centered: true
    },
    MANAGE_ADDRESS_MODAL: {
      windowClass: 'modal fade come-from-modal bottom-modal manage-address-modal',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    TAX_AND_CHARGES_CONFIG: {
      windowClass: 'tax-and-charges-modal',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    THANKSFOR_RATING_CONFIG: {
      windowClass: 'thanks-for-rating-modal',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    COUPON_CONFIRMATION_CONFIG: {
      windowClass: 'coupon-confirmation-modal',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    REFERRAL_CODE_MODAL_CONFIG: {
      windowClass: 'addon-variant-modal-css',
      backdrop: true,
      scrollable: true,
      centered: true
    },
    ORDER_DELIVER_RATING_MODAL_CONFIG: {
      windowClass: 'delivery-rating-modal-css',
      backdrop: true,
      scrollable: true,
      centered: true
    },
    SCRATCH_CARD_CONFIG: {
      ORDER_TRACK: {
        windowClass: 'scratch-card-order-track come-from-modal right',
        backdrop: true,
        scrollable: false,
        centered: true
      },
      EARNED_CARDS: {
        windowClass: 'scratch-card-earned',
        backdrop: true,
        scrollable: false,
        centered: true
      }
    },
    NO_INTERNET_CONFIG: {
      windowClass: 'no-internet-modal-css',
      backdrop: true,
      scrollable: true,
      centered: true
    },
    ORDER_TRACK_MODAL: {
      windowClass: 'modal fade come-from-modal right order-track-modal',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    CENTER_CONFIRM_MODAL_CONFIG: {
      windowClass: 'center-confirmation-modal-css',
      backdrop: true,
      scrollable: false,
      centered: true
    },
    LINK_ACCOUNT_CONFIG: {
      windowClass: 'center-confirmation-modal-css',
      keyboard: false,
      scrollable: false,
      centered: true
    }

  };

  return CONFIG[type];
}

export function getMessages(type) {
  const MESSAGES = {
    LOGOUT_MSG: {
      title: 'Logging Out?',
      msg: 'Are you sure you want to sign out?',
      btnClose: 'I will stay',
      btnConfirm: 'Logout',
      isLogout: true
    },
    DELETE_ADDRESS_MSG: {
      title: 'Do you want to remove this address ?',
      msg: "By clicking 'Delete', this address will be removed completely.",
      btnClose: 'Cancel',
      btnConfirm: 'Delete',
      isDelete: true
    },
    CLEAR_ALL_DISH_MSG: {
      title: 'Clear',
      msg: 'Clear all Dishes from your Plate?',
      btnClose: 'Cancel',
      btnConfirm: 'Clear all',
      isClearAllDish: true
    },
    CLEAR_PLATE_MSG: {
      title: '',
      msg: '',
      previousOutlet: '',
      newOutlet: '',
      btnClose: 'Cancel',
      btnConfirm: 'Replace',
      isPLateClear: true
    },
    OUTLET_MENU_CLOSE_MSG: {
      title: '',
      msg: '',
      btn: 'Cancel',
      isOutletClose: true
    },
    PAYMENT_CANCEL: {
      title: 'Are you Sure?',
      msg: "By going back, your payment will be cancelled.",
      btnClose: 'NO',
      btnConfirm: 'YES',
      isDelete: true
    },
    DELETE_ACCOUNT: {
      title: 'Are we breaking up?',
      emoji:'<img src="assets/icon/account/icon-tear.svg" style="width:22px; margin-bottom:2px" />',
      msg: "By deleting, your account will be removed permanently.",
      btnClose: 'NO',
      btnConfirm: 'YES',
      isDelete: true
    }
  };
  return MESSAGES[type];
}

export const ADDRESS_BY_CITY = {
  types: [],
  componentRestrictions: { country: 'IN' },
  fields: ['address_components', 'geometry', 'place_id', 'formatted_address'],
};

export function currentOrderStatus(orderStatus) {
  const type = {
    cancelled: { index: '' },
    rejected: { index: '' },
    inDispute: { index: '' },
    enforcedCancel: { index: '' },
    acceptanceWait: { index: 0 },
    valetOnWayToConfirm: { index: '' },
    foodPreparation: { index: 1 },
    foodReady: { index: 1 },
    waitingDeliveryPickup: { index: 1 },
    pickup_complete: { index: 1 },
    started_for_delivery: { index: 1 },
    outForDelivery: { index: 2 },
    delivered: { index: 2 },
    complete: { index: '' }
  };

  return type[orderStatus].index;
}

export function currentOrderStatusIndex(statusObj) {
  let index = '';
  if (statusObj.deliveryStatus === 'pickup_complete' || statusObj.deliveryStatus === 'started_for_delivery' || statusObj.deliveryStatus === 'delivered') {
    index = currentOrderStatus(statusObj.deliveryStatus);
  } else {
    index = currentOrderStatus(statusObj.orderStatus);
  }

  return index;
}

export const ERROR_CART_MESSAGES = {
  1010: {
    imgUrl: 'assets/icon/cart/item-not-aval.svg',
    title: 'not serving',
    desc: '',
    subTitle: '',
    btnTxt: 'Update your cart',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'red-title-txt',
    btnAction: 'ITEM_NOT_SERVING'
  },
  1011: {
    imgUrl: 'assets/icon/restaurant/restaurant not available_icon.svg',
    title: 'Restaurant is closed',
    desc: '',
    subTitle: '',
    btnTxt: 'View other restaurants',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'red-title-txt',
    btnAction: 'OUTLET_NOT_SERVING'
  },
  1012: {
    imgUrl: ' ',
    title: '',
    desc: '',
    subTitle: '',
    btnTxt: '',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'red-title-txt',
    btnAction: 'OFFER_INVALID'
  },
  1013: {
    imgUrl: ' ',
    title: '',
    desc: '',
    subTitle: '',
    btnTxt: '',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'red-title-txt',
    btnAction: 'OFFER_MIN_ORDER'
  },
  1014: {
    imgUrl: 'assets/icon/cart/delivery not available.svg',
    title: 'Delivery person unavailable',
    desc: 'There are currently no riders in the area..',
    subTitle: '',
    btnTxt: 'View other restaurants',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'red-title-txt',
    btnAction: 'DELIVERY_PERSON_UNAVAILABLE'
  },
  1015: {
    imgUrl: 'assets/icon/cart/location-not-available.svg',
    title: 'Location unserviceable',
    desc: 'We are not serving this location.',
    subTitle: '',
    btnTxt: 'Change address',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'red-title-txt',
    btnAction: 'LOCATION_UNSERVICEABLE'
  },
  'DELIVERY_ADDRESS': {
    imgUrl: '',
    title: 'payment',
    desc: '',
    subTitle: 'Change address',
    btnTxt: '',
    btnClassCSS: 'btn-green-bg',
    titleCss: 'black-title-txt',
    btnAction: 'PLACE_ORDER'
  },
  'ADD_ADDRESS': {
    imgUrl: 'assets/icon/cart/new-location.svg',
    title: 'You are in new location !',
    desc: '',
    subTitle: '',
    btnTxt: 'Add Address',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'black-title-txt',
    btnAction: 'ADD_ADDRESS'
  },
  'SELECT_ADDRESS': {
    imgUrl: 'assets/icon/cart/new-location.svg',
    title: 'You are in new location !',
    desc: '',
    subTitle: '',
    btnTxt: 'Select Address',
    btnClassCSS: 'btn-red-bg',
    titleCss: 'black-title-txt',
    btnAction: 'SELECT_ADDRESS'
  },
  'LOGIN': {
    imgUrl: '',
    title: '',
    desc: '',
    subTitle: '',
    btnTxt: 'Login',
    btnClassCSS: 'btn-green-bg',
    titleCss: 'black-title-txt',
    btnAction: 'LOGIN'
  }
}

export const LOGIN_SIGNUP_TEXT = {
  main: {
    login: 'Explore amazing deals on restaurants near you. Login now.',
    signup: 'Explore amazing deals on restaurants near you. Create an account to start ordering.'
  },
  cart: {
    login: 'Tasty food awaits you. Login to continue with your order.',
    signup: 'Tasty food awaits you. Create an account to place your order.'
  },
  invite: {
    login: 'Login now to start referring Yumzy.',
    signup: 'Create an account to start referring Yumzy.'
  }
}

export const ADDRESS_TAG_IMG = {
  home: 'assets/icon/cart/deliver-to-home.svg',
  office: 'assets/icon/cart/deliver-to-office.svg',
  others: 'assets/icon/cart/deliver-to-other.svg'
}

export const CHARGES = {
  packingCharges: 'Packing Charges',
  restaurantCharges: 'Restaurant Charges',
  surgeCharges: 'Surge Charges',
  deliveryCharge: 'Delivery Charges'

}

export const EMPTY_PLATE = {
  YES: 'YES',
  NO: 'NO'
}

export const ORDER_TRACK_URLS = {
  MAPS_ICON_URLS: {
    mapsMarkerUrl: 'assets/icon/address/maps-marker.svg',
    locationPointRedUrl: 'assets/icon/address/location-point-red-icon.svg',
    riderUrl: 'assets/images/address/rider.png',
    restLocationUrl: 'assets/icon/address/rest-location-2.svg',
    homeLocationUrl: 'assets/icon/address/home-location.svg'
  },
  ORDER_STATUS_URLS: {
    foodReadyGrey: 'assets/icon/address/food-ready-grey.svg',
    foodReadyRed: 'assets/icon/address/food-ready-red.svg',
    foodReadyGreen: 'assets/icon/address/food-ready-green.svg',
    foodOnTheWayGrey: 'assets/icon/address/food-on-way-grey.svg',
    foodOnTheWayRed: 'assets/icon/address/food-on-way-red.svg',
    foodOnTheWayGreen: 'assets/icon/address/food-on-way-green.svg',
    orderPickedUpGrey: 'assets/icon/address/order-pickedup-grey.svg',
    orderPickedUpRed: 'assets/icon/address/order-pickedup-red.svg',
    orderPickedUpGreen: 'assets/icon/address/order-pickedup-green.svg',
    orderReceivedGrey: 'assets/icon/address/order-received-grey.svg',
    orderReceivedRed: 'assets/icon/address/order-received-red.svg',
    orderReceivedGreen: 'assets/icon/address/order-received-green.svg'
  }
}

export const MAP_ICONS = {

  renderOptions: {
    polylineOptions: {
      strokeColor: '#fc6f7f',
      strokeWeight: '2.5'
    },
    suppressMarkers: true,
    suppressInfoWindows: true
  },

  markerOptions: {
    origin: {
      infoWindow: 'Origin.',
      icon: {
        url: ORDER_TRACK_URLS.MAPS_ICON_URLS.riderUrl,
        scaledSize: { width: 20, height: 30 },
        rotation: 90
      }
    },
    destination: {
      infoWindow: 'Destination',
      icon: ORDER_TRACK_URLS.MAPS_ICON_URLS.homeLocationUrl,
      size: { width: 20, height: 30 }
    }
  },

  riderIcon: {
    url: ORDER_TRACK_URLS.MAPS_ICON_URLS.riderUrl,
    scaledSize: { width: 20, height: 30 }
  },

  restLocationIcon: {
    url: ORDER_TRACK_URLS.MAPS_ICON_URLS.restLocationUrl,
    scaledSize: { width: 30, height: 30 }
  },

  userLocationIcon: {
    url: ORDER_TRACK_URLS.MAPS_ICON_URLS.homeLocationUrl,
    scaledSize: { width: 30, height: 30 }
  }
}

export const ORDER_STATUS_TO_DISPLAY = [
  'Order Accepted',
  'Food is being prepared',
  'Order Delivered'
];

export const ORDER_STATUS_LIST = {
  REJECTED_LIST: ['cancelled', 'rejected', 'inDispute', 'enforcedCancel'],
  PROCESSING_LIST: ['acceptanceWait', 'valetOnWayToConfirm', 'foodPreparation', 'foodReady', 'waitingDeliveryPickup', 'outForDelivery'],
  DELIVERED_LIST: ['delivered', 'complete']
}

export const KEYS_TO_SHOW_RIDER_DETAILS = [
  'runner_accepted', 'reached_for_pickup', 'pickup_complete', 'started_for_delivery', 'reached_for_delivery'
]

export const RATING_STATUS_DECLARATION = {
  process: [
    { name: "Packaging", url: 'assets/icon/rate/rate-packaging.svg', width: 72 },
    { name: "Taste", url: 'assets/icon/rate/rate-taste.svg', width: 60 },
    { name: "Portion size", url: 'assets/icon/rate/rate-portion-size.svg', width: 60 }
  ],
  statusOfDelivery: [
    { name: 'I loved it' },
    { name: 'I didn\'t like it' },
    { name: 'Delivery Executive was good' },
    { name: 'Delivery was fast!' },
    { name: 'Delivery Executive was rude' },
    { name: 'Late Delivery' }
  ]

}

export const RATING = {
  BAD_RATTING: ['Executive Behaviour', 'Delivery time', 'Package handling'],
  AVERAGE_RATING: ['Executive Behaviour', 'Delivery time', 'Package handling'],
  GOOD_RATING: ['Executive Behaviour', 'Delivery time', 'Package handling'],
}

export const FEEDBACK_STATUS_MAPPING = {
  1: 'Disappointed',
  2: 'Not Great',
  3: 'Satisfied',
  4: 'Good',
  5: 'Excellent'
}

export const FEEDBACK_STATUS_COLOR_MAPPING = {
  'Disappointed': '#DD2D4A',
  'Not Great': '#DD2D4A',
  'Satisfied': '#FF953B',
  'Good': '#119839',
  'Excellent': '#119839'
}


export const PAYMENT_TYPE = {
  'paymentGateway': 'PAYMENT GATEWAY',
  'wallet': 'WALLET',
  'netbanking': 'NETBANKING'
}

export const SCRATCH_CARDS = {
  blueCard: 'assets/scratch-cards/blue.jpg',
  greenCard: 'assets/scratch-cards/green.jpg',
  pinkCard: 'assets/scratch-cards/pink.jpg',
  yellowCard: 'assets/scratch-cards/yellow.jpg',
  orangeCard: 'assets/scratch-cards/orange.jpg',
  whiteCard: 'assets/scratch-cards/white.png',
}

export const ICONS_ON_CARDS = {
  coupon: 'assets/scratch-cards/icons-on-card/coupon.svg',
  dollar: 'assets/scratch-cards/icons-on-card/dollar.svg',
  rupee: 'assets/scratch-cards/icons-on-card/rupee.svg',
  watermelon: 'assets/scratch-cards/icons-on-card/watermelon.svg',
  chacha: 'assets/scratch-cards/icons-on-card/scratched_card.png',
  background: 'assets/scratch-cards/icons-on-card/background.svg'
}

export const MANAGE_ADDRESS_ICONS = {
  "home": "icon-home",
  "office": "icon-suitcase",
  "others": "icon-location-on"
}

export const MY_REWARD_CARDS = [
  {
    imageUrl: 'assets/scratch-cards/scratch-summary-icons/yumzy-wallet-icon.png',
    title: 'Wallet',
    subTitle: 'Yumzy Wallet',
    route: '/my-wallet'
  },
  {
    imageUrl: 'assets/scratch-cards/scratch-summary-icons/scratch-icon.png',
    title: 'Scratch Card',
    subTitle: 'Scratch Card',
    route: '/earned-scratch-cards'
  }
]

export const REDEEM_TYPE = {
  CASHBACK: 80,
  THIRD_PARTY: 81
}

export const NAVIGATE_THROUGHT_NOTIFICATION = {
  home: '/home',
  reward: '/earned-scratch-cards',
  explore: '/explore',
  plate: '/cart',
  wallet: '/my-wallet',
  invite: '/home',
  favourites: '/favorites',
  food_pref: '/food-preferences',
  offer: '/offers',
  order_tracking: '/order-tracking',
  order_history: '/order-history',
  order_details: '/order-details',
  manage_address: '/manage-address',
  promo_outlet: '/see-all-restaurants',
  promo_dish: '/see-all-dish',
  dish: '/rest-details',
  outlet: '/rest-details',
  update: '',
  scratch_card: '/earned-scratch-cards',
  account: '/account',
  login: '/login',
  signup: '/sign-up',
  welcome: '/welcome',
  help_faqs: '/help-faqs',
  referEarn: '/refer-earn'
}


export const AGM_MAP_CUSTOM_STYLES = [
  {
    featureType: "all",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }]
  }, {
    featureType: "road",
    elementType: "labels",
    stylers: [{ visibility: "on" }]
  }, {
    featureType: "poi",
    stylers: [{ visibility: "off" }]
  }, {
    featureType: "transit",
    stylers: [{ "visibility": "off" }]
  }
]

export const OFFER_COLORS = [
  {
    backgroundColor: "#F672801A",
    border: "#BC3357"
  },
  {
    backgroundColor: "#9072F61A",
    border: "#4833BC"
  },
  {
    backgroundColor: "#72F6AA1A",
    border: "#43BC33"
  }
]

export const WELCOME_PAGE_IMAGES = [
  {
    src: 'https://sgp1.digitaloceanspaces.com/listing/yumzy/app/images/welcome/wide_range.png',
    title: 'Wide range of dishes',
    desc: 'Discover new flavours and delicacies from the best restaurants.'
  },
  {
    src: 'https://sgp1.digitaloceanspaces.com/listing/yumzy/app/images/welcome/order_anywhere.png',
    title: 'Order from anywhere',
    desc: 'Experience deliveries at rocket speed from anywhere in your city.'
  },
  {
    src: 'https://sgp1.digitaloceanspaces.com/listing/yumzy/app/images/welcome/reward.png',
    title: 'Rewards on every order',
    desc: 'Earn assured cashback and coupons on every order.'
  }
];

export const ROUTES_STR = {
  home: "/home",
  account: "/account",
  explore: "/explore",
  cart: "/cart",
  welcome: "/welcome",
  noInternet: "/no-internet",
  orderHistory: "/order-history",
  payments: "/payments",
  orderConfirmation:'/order-confirmation'
};

export const PLACEHOLDER_IMGS = {
  banners: [
    "assets/images/v3/placeholder-images/banner-pink.png",
    "assets/images/v3/placeholder-images/banner-grey.png",
  ],
  circleImgs: "assets/images/v3/placeholder-images/green-circle.svg",
  squareImgs: [
    "assets/images/v3/placeholder-images/violet-rect.svg",
    "assets/images/v3/placeholder-images/light-yellow-rect.svg",
    "assets/images/v3/placeholder-images/light-green-rect.svg",
    "assets/images/v3/placeholder-images/light-blue-rect.svg",
  ],
  mcDonald: "assets/images/v3/placeholder-images/mc-donald.png",
};

export const FIREBASE_CONFIG_KEY = {
  app_background_time: 'app_background_time',
  tracking_frequency: 'tracking_frequency',
  offer_display_type: 'offer_display_type',
  payment_gateway: 'payment_gateway',
  homes_refresh_time: 'homes_refresh_time',
  page_limit: 'page_limit',
  top_header_style: 'top_header_style',
  item_image_base_url:'item_image_base_url',
}
export const FIREBASE_CONFIG_DEFAULT = {
  app_background_time: 20000,
  tracking_frequency: 15000,
  homes_refresh_time: 300000,
  page_limit: 8,
  payment_gateway: 'web',
  offer_display_type: {
    "width": "100%",
    "bottom": "0px",
    "background": "#bc3357",
    "color": "white",
    "border-radius": "0px 0px 16px 16px",
    "text-align": "center",
    "font-weight": "normal",
  },
  item_image_base_url:'',
  top_header_style: {
    scrollAnimation: false,
    style: {
      background: '',
    }
  }

}

export const UPI_PATTERN = /^(([^<>!#$%&\^\*()\[\]\\.,;:\s@'"?`~]+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+)+[a-zA-Z]{2,}))$/;




export const PAYMENT_LIST_ID = {
  WALLET: 'wallet',
  NETBANKING: 'net_banking',
  CARD: 'card',
  UPI: 'upi',
  COD: 'cod'
}

export const PAYMENT_LIST_ICON = {
  wallet: 'icon-wallet',
  net_banking: 'icon-globe',
  card: 'icon-credit-card',
  upi: 'icon-bhim',
  cod: 'icon-payment-cash'

}

export const WALLET_PAYMENT_TYPE = {
  payTm: 'paytm',
  freeCharge: 'freecharge',
  lazyPay: 'lazypay',
  phonePe: 'phonepe',
  amazonPay: 'amazonpay',
  wallet: 'wallet'
}
export var isAddCardObj = {
  addNewCard: false
};
export const CURRENCY_CODE = {
  'usd': '$',
  'inr': '₹'
}

export const ITEM_LAYOUT_SPACE = {
  1.0: 66,
  1.1: 59,
  1.2: 52,
  1.3: 46,
  1.4: 41,
  1.5: 36,
  1.6: 33,
  1.7: 29,
  1.8: 27,
  1.9: 24,
  2.0: 22,
  2.1: 19,
}

export const UPI_APP_LINKS = {
  android: {
    paytm: { package: "net.one97.paytm", type: "package" },
    googlepay: { package: "com.google.android.apps.nbu.paisa.user", type: "package" },
    phonepe: { package: "com.phonepe.app", type: "package" },
    bhimupi: { package: "upi://pay", type: "url" }
  },
  ios: {
    paytm: { package: "paytmmp://pay", type: "url" },
    googlepay: { package: "tez://upi/pay", type: "url" },
    phonepe: { package: "phonepe://pay", type: "url" },
    bhimupi: { package: "upi://pay", type: "url" }
  }
}